// Firebase Collection Names
export const USERS_COL = "users";
export const PROJECTS_COL = "projects";
export const AVATAR_COL = "avatar";
export const SUBSCRIPTIONS_COL = "subscriptions";
